// Anything we attach "custom" to the global namespace should be added to `window.acornsweb` instead of added directly to `window`
// (less pollution on the global `window` object, better organization for "our" stuff , and less chance of field collisions).
export function initializeAcornsWebGlobalNamespace() {
  var _window$acornsweb;

  var _window = window;
  _window.acornsweb = (_window$acornsweb = _window.acornsweb) !== null && _window$acornsweb !== void 0 ? _window$acornsweb : {};
}